// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-q_gv","advertDetailParameterList__header":"c-q_gw","advertDetailParameterList__list":"c-q_gx"};